import { PUBLIC_VSS_USER_ID } from "_constants/GlobalConstants";

export const addMenuItem = (item, user) => {
    return item.isPublic === true || (user && user.volUserId !== PUBLIC_VSS_USER_ID && user.navigation[item.key] === true);
}